import { Component, Input } from '@angular/core';
import { UniCampaignsPermissionsService } from '../../shared/uni-campaign-permissions.service';
import { Campaign, CampaignStatus } from '../../shared/uni-campaign.model';
import { SmsCounter } from '../../../../shared/uni-sms-counter.utils';
import { DateUtils } from '../../../../utils/date.utils';
import { getSendingPercentage } from '../campaign-progress/campaign-progress.helper';
import { UniNumberService } from '../../../../shared';

@Component({
  selector: 'cc-campaign-status',
  templateUrl: './campaign-status.component.html',
  styleUrls: ['./campaign-status.component.scss']
})
export class CampaignStatusComponent {
  @Input() campaign: Campaign;
  campaignStatus = CampaignStatus;
  dateUtils = DateUtils;
  isModalActive = false;
  smsCounter = SmsCounter;
  getSendingPercentage = getSendingPercentage;

  constructor(
    public campaignPermissionsService: UniCampaignsPermissionsService,
    private uniNumberService: UniNumberService,
  ) { }

  openModal(): void {
    this.isModalActive = true;
  }

  canDelete(): boolean {
    return this.campaignPermissionsService.canDeleteScheduled();
  }

  getUnitCost(): string {
    const smsCount = this.smsCounter.init(this.campaign.content).smsLength;
    const unitCost = this.campaign.recipientsCount * smsCount;

    return !unitCost
      ? '0'
      : this.uniNumberService.formatShortNumber(unitCost);
  }

  isRejectionReason(campaign: Campaign): boolean {
    return !!campaign.rejectionReason
      && campaign.status === this.campaignStatus.rejected;
  }
}
